import { Capacitor } from "@capacitor/core";
import env from "@/env";

const CHECK_INTERVAL_MS = 60 * 1000;
const REQUEST_TIMEOUT_MS = 3000;

let lastCheckAt = 0;
let isOutdated = false;

async function fetchDeployedBuildId() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
      signal: controller.signal,
    });
    if (!response.ok) return null;
    const { buildId } = await response.json();
    return buildId || null;
  } catch (e) {
    return null;
  } finally {
    clearTimeout(timeout);
  }
}

async function checkForNewDeploy() {
  if (isOutdated || Date.now() - lastCheckAt < CHECK_INTERVAL_MS) {
    return isOutdated;
  }
  lastCheckAt = Date.now();
  const deployedBuildId = await fetchDeployedBuildId();
  isOutdated = Boolean(deployedBuildId) && deployedBuildId !== env.buildId;
  return isOutdated;
}

export default {
  install(app) {
    if (
      Capacitor.getPlatform() !== "web" ||
      process.env.NODE_ENV !== "production" ||
      !env.buildId
    ) {
      return;
    }

    // A freshly loaded page already runs the deployed build.
    lastCheckAt = Date.now();
    const router = app.config.globalProperties.$router;

    // Reloading on navigation lands the user on the page they asked for, already running the new build.
    router.beforeEach(async (to) => {
      if (await checkForNewDeploy()) {
        window.history.pushState(null, "", router.resolve(to).href);
        window.location.reload();
        return false;
      }
    });

    document.addEventListener("visibilitychange", async () => {
      if (document.visibilityState === "visible" && (await checkForNewDeploy())) {
        window.location.reload();
      }
    });
  },
};
